import { useContext, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import { Auth } from "../../StateManagment/Auth.js";
import {
  useFirestoreGeneral,
  useFirestoreGeneralArrayContains,
  useFirestoreGeneralIn,
} from "../../firebase/useFirestore.js";
import {
  buildStreetLabelMap,
  householdLabel,
  phoneLabel,
} from "../../helpers/adressHelpers/buildStreetLabels.js";
import { ADDRESS_LABEL_TITLES, HOUSEHOLD_FIELDS } from "../../helpers/adressHelpers/householdFields.js";
import CallLink from "../../components/mobile/CallLink.jsx";
import useStatusDisplays from "../../hooks/useStatusDisplay";

// Straat en nummer voor het label, plus de titels waaronder een telefoonnummer
// kan staan. Samen ruim binnen de tien waarden die een Firestore `in` aankan.
// Oude titels voor straat en telefoon, de terugval tot de migratie; straat
// en telefoon staan voortaan op het huishouden (T10).
// AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md
const HOUSEHOLD_LIST_TITLES = [...ADDRESS_LABEL_TITLES, ...HOUSEHOLD_FIELDS.Telefoon.legacyTitles];

/**
 * Mobile list of the households the logged-in user is assigned to
 * (Adresses.AssignedTo, set on the desktop "Toegewezen aan" column).
 *
 * Tasks and households are both assigned to personas, not to user accounts —
 * the logged-in user's persona is found via Personas.UserID, the same link
 * MobileCalendarUser uses.
 *
 * Het telefoonnummer staat naast het adres omdat de fixer onderweg alleen een
 * telefoon bij zich heeft: voor een dichte deur moet hij kunnen bellen zonder
 * eerst het huishouden te openen.
 */
const MobileMyHouseholds = () => {
  // Context
  const [auth] = useContext(Auth);

  // Hooks
  const history = useHistory();
  const { orgId } = useParams();

  // Firestore
  const myPersonas = useFirestoreGeneral("Personas", "UserID", auth?.ID || "");
  const statusDisplay = useStatusDisplays().adress;
  const myPersonaId = (Array.isArray(myPersonas) ? myPersonas[0]?.ID : "") || "";

  const households = useFirestoreGeneralArrayContains("Adresses", "AssignedTo", myPersonaId);

  const streetData = useFirestoreGeneralIn("PersonaData", "Title", HOUSEHOLD_LIST_TITLES);

  const streetByAddressId = useMemo(() => buildStreetLabelMap(streetData, households), [streetData, households]);

  const items = Array.isArray(households) ? households : [];

  return (
    <div className="mobile-page">
      <h2 className="mobile-page-heading">Mijn huishoudens</h2>

      {items.length === 0 ? (
        <p className="mobile-empty-message">Er zijn geen huishoudens aan je toegewezen.</p>
      ) : (
        <ul className="mobile-household-list">
          {items.map((item) => (
            <li key={item.ID} className="mobile-household-card">
              <button
                className="mobile-household-list-item"
                onClick={() => history.push(`/${orgId}/myhousehold/${item.ID}`)}
              >
                <HomeWorkOutlinedIcon />
                <span className="mobile-household-list-item-body">
                  <span className="mobile-household-list-item-title">
                    {householdLabel(streetByAddressId, item)}
                  </span>
                  <span className="mobile-household-list-item-status">
                    {statusDisplay.labels[item.Status] || "Geen status"}
                  </span>
                </span>
                <ChevronRightOutlinedIcon />
              </button>
              <CallLink
                phone={phoneLabel(streetByAddressId, item.ID, "")}
                label={householdLabel(streetByAddressId, item)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MobileMyHouseholds;
